import { Link } from 'react-router-dom'
import { ChatLinkIcon } from './ChatLinkIcon'
import { useChatEntityNames } from './chatEntityNames'

type CuidEntityLinkProps = {
  cuid: string
  to: string
  className?: string
}

/** Renders a known admin CUID deep link; shows the entity name when available (no cuid in the label). */
const CuidEntityLink: React.FC<CuidEntityLinkProps> = ({ cuid, to, className }) => {
  const known = useChatEntityNames()
  const name = known[cuid]?.name?.trim() || null
  const label = name ?? cuid

  return (
    <Link to={to} className={className} aria-label={label}>
      <ChatLinkIcon kind="internal" href={to} />
      <span className="min-w-0 underline underline-offset-2">
        {name ? (
          <span className="font-normal">{name}</span>
        ) : (
          <span className="font-mono text-[12px]">{cuid}</span>
        )}
      </span>
    </Link>
  )
}

export default CuidEntityLink
